import React from "react";

const dayjs = require("dayjs");

const rowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flexWrap: "wrap",
};

const groupStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const labelStyle = {
  margin: 0,
  fontSize: "13px",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

const valueStyle = {
  fontSize: "13px",
  color: "#212529",
};

const refreshBtnStyle = {
  padding: "4px 10px",
  fontSize: "13px",
  border: "1px solid #28a745",
  borderRadius: "4px",
  background: "#28a745",
  color: "#fff",
  cursor: "pointer",
  fontWeight: 500,
};

const editBtnStyle = {
  padding: "4px 10px",
  fontSize: "13px",
  border: "1px solid #0d6efd",
  borderRadius: "4px",
  background: "#fff",
  color: "#0d6efd",
  cursor: "pointer",
  fontWeight: 500,
};

const inputStyle = {
  padding: "4px 8px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  fontSize: "13px",
};

function StatGroup({ label, children, style }) {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <span style={labelStyle}>{label}</span>
      {children}
    </div>
  );
}

function formatFyStartDate(currentFyStartDate) {
  return currentFyStartDate && dayjs(currentFyStartDate, "YYYY-MM-DD", true).isValid()
    ? dayjs(currentFyStartDate).format("MM/DD/YYYY")
    : "—";
}

function TrailingStats({ todayDate, daysElapsed, pctFyElapsed }) {
  return (
    <>
      <StatGroup label="Today Date" style={{ marginLeft: "8px" }}>
        <span style={valueStyle}>{todayDate}</span>
      </StatGroup>
      <StatGroup label="Days Elapsed">
        <span style={valueStyle}>{daysElapsed != null ? daysElapsed : "—"}</span>
      </StatGroup>
      <StatGroup label="% FY Elapsed">
        <span style={valueStyle}>
          {pctFyElapsed != null ? `${pctFyElapsed}%` : "—"}
        </span>
      </StatGroup>
    </>
  );
}

export default function OperatingPlanFyStatsRow({
  currentFy,
  currentFyStartDate,
  todayDate,
  daysElapsed,
  pctFyElapsed,
  editMode = false,
  fiscalYearOptions = [],
  onCurrentFyChange,
  onCurrentFyStartDateChange,
  onEdit,
  onSave,
  onCancel,
  onRefresh,
  showEdit = false,
  showRefresh = false,
}) {
  if (editMode) {
    return (
      <div className="operating-plan-fy-stats-row" style={rowStyle}>
        <StatGroup label="Current FY">
          <select
            id="current-fy"
            value={currentFy}
            onChange={(e) => onCurrentFyChange(e.target.value)}
            style={{ ...inputStyle, minWidth: "100px" }}
          >
            {fiscalYearOptions.map((fy) => (
              <option key={fy} value={fy}>
                {fy}
              </option>
            ))}
          </select>
        </StatGroup>
        <StatGroup label="Current FY Start Date">
          <input
            id="current-fy-start-date"
            type="date"
            value={currentFyStartDate}
            onChange={(e) =>
              onCurrentFyStartDateChange(
                e.target.value || dayjs().startOf("year").format("YYYY-MM-DD")
              )
            }
            title="mm/dd/yyyy"
            style={{ ...inputStyle, minWidth: "140px" }}
          />
        </StatGroup>
        <button
          type="button"
          onClick={onSave}
          style={refreshBtnStyle}
        >
          Save
        </button>
        <button
          type="button"
          onClick={onCancel}
          style={{
            padding: "4px 10px",
            fontSize: "13px",
            border: "1px solid #6c757d",
            borderRadius: "4px",
            background: "#fff",
            color: "#6c757d",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
        <TrailingStats
          todayDate={todayDate}
          daysElapsed={daysElapsed}
          pctFyElapsed={pctFyElapsed}
        />
      </div>
    );
  }

  return (
      <div className="operating-plan-fy-stats-row" style={rowStyle}>
      <StatGroup label="Current FY">
        <span style={valueStyle}>{currentFy || "—"}</span>
      </StatGroup>
      <StatGroup label="Current FY Start Date">
        <span style={valueStyle}>{formatFyStartDate(currentFyStartDate)}</span>
      </StatGroup>
      {showEdit && (
        <button type="button" onClick={onEdit} style={editBtnStyle}>
          Edit
        </button>
      )}
      {showRefresh && (
        <button type="button" onClick={onRefresh} style={refreshBtnStyle}>
          Refresh
        </button>
      )}
      <TrailingStats
        todayDate={todayDate}
        daysElapsed={daysElapsed}
        pctFyElapsed={pctFyElapsed}
      />
    </div>
  );
}
